module.exports = __webpack_public_path__ + "img/icon-youtube.6b24e12dd87d8d3e321c12025999daed.svg";